import { ToastContainer, toast } from 'react-toastify';

let widthContainer;

export const notify = (type, msg, config = {}) => {
  const width = config?.width ?? 320;

  const toastConfig = {
    position: 'top-center',
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: {
      width,
    },
    ...config,
  };

  widthContainer = width;

  switch (type) {
    case 'success':
      return toast.success(msg, toastConfig);
    case 'error':
      return toast.error(msg, toastConfig);
    case 'warning':
      return toast.warn(msg, toastConfig);
    case 'info':
      return toast.info(msg, toastConfig);
    case 'pending':
      return toast.info(msg, {
        ...toastConfig,
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
      });
    case 'update':
      return toast.update(msg, toastConfig);
    default:
      return toast(msg, toastConfig);
  }
};

export function dismissNotification(notificationId) {
  toast.dismiss(notificationId);
}

export function NotificationContainer() {
  return <ToastContainer theme="colored" style={{ width: widthContainer }} />;
}
